import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientAllocationActions, IThunkValidateAvailability } from '../types';

const onValidateAvailability: IThunkValidateAvailability = thunk(
  async (
    { setClientAllocationAvailability }: Actions<IClientAllocationActions>,
    { clinicId, payload },
  ) => {
    if (!payload.clientAllocations.length) {
      setClientAllocationAvailability(null);
      return;
    }

    const response = await api.clientAllocation.validateAvailability(clinicId, payload);

    setClientAllocationAvailability(response.data);
  },
);

export default onValidateAvailability;
